import PropTypes from 'prop-types';
import React from 'react';

class HotelListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selected: props.hotel.selected, favorite: props.hotel.favorite };
    this.handleChange = this.handleChange.bind(this);
    this.handleFavorite = this.handleFavorite.bind(this);
    this.handleDisplay = this.handleDisplay.bind(this);
  }

  handleChange(e) {
    e.preventDefault();

    this.setState(prevState => ({
      selected: !prevState.selected,
    }));
    this.props.selectHotel({ hotel: this.props.hotel.id, selected: !this.state.selected });
  }
  handleFavorite(e) {
    e.preventDefault();
    this.setState(prevState => ({
      favorite: !prevState.favorite,
    }));
    this.props.favoriteHotel(this.props.hotel.id, !this.state.favorite);
  }
  handleDisplay(e) {
    e.preventDefault();
    this.props.displayHotel(this.props.hotel.id);
  }

  render() {
    const color = this.props.hotel.management ? 'green' : '';
    return (
      <li
        style={{
          color,
          borderBottom: '1px solid #f0f0f0',
          paddingTop: 10,
          paddingBottom: 10,
        }}
      >
        <div className="hotel-name">
          <input
            id={this.props.hotel.id}
            type="checkbox"
            checked={this.state.selected}
            onChange={this.handleChange}
          />
          <span
            className={this.state.favorite ? 'fa fa-heart text-danger' : 'fa fa-heart-o'}
            onClick={this.handleFavorite}
            role="button"
          />
          <span className="pointer-hover" onClick={this.handleDisplay} role="presentation">
            <span>
              {this.props.hotel.name}&nbsp;
              {this.props.hotel.management && <i className="fa fa-check-circle" />}
            </span>
          </span>
          <div>
            <div className="hotel-distance">
              {this.props.hotel.stars ? this.props.hotel.stars : '?'}{' '}
              <span className="fa fa-star" />
              <a
                href={this.props.hotel.website}
                title={this.props.hotel.website}
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className={this.props.hotel.website ? 'fa fa-external-link' : 'hidden'} />
              </a>
              <span>
                ({parseFloat(this.props.hotel.distance * 0.621371).toFixed(2)} mi. from venue)
              </span>
            </div>
          </div>
        </div>
        <div className="hotel-details text-muted">
          <p>
            <i className="fa fa-map-marker" />
            {this.props.hotel.address}, &nbsp;
            {this.props.hotel.locality}, &nbsp;
            {this.props.hotel.region}, &nbsp;
            {this.props.hotel.postcode}, &nbsp;
            {this.props.hotel.tel},
          </p>
        </div>
      </li>
    );
  }
}

HotelListItem.propTypes = {
  hotel: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    selected: PropTypes.bool.isRequired,
    favorite: PropTypes.number.isRequired,
    address: PropTypes.string,
    locality: PropTypes.string,
    region: PropTypes.string,
    postcode: PropTypes.string,
    tel: PropTypes.string,
    website: PropTypes.string,
    distance: PropTypes.number,
    stars: PropTypes.number,
    management: PropTypes.object,
  }),
  favoriteHotel: PropTypes.func.isRequired,
  selectHotel: PropTypes.func.isRequired,
  displayHotel: PropTypes.func.isRequired,
};

HotelListItem.defaultProps = {
  hotel: {
    selected: false,
  },
};
export default HotelListItem;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelListItem.js